import { render, staticRenderFns } from "./CatalogueFieldsMapper.vue?vue&type=template&id=b112c06a&scoped=true"
import script from "./CatalogueFieldsMapper.vue?vue&type=script&lang=js"
export * from "./CatalogueFieldsMapper.vue?vue&type=script&lang=js"
import style0 from "./CatalogueFieldsMapper.vue?vue&type=style&index=0&id=b112c06a&prod&lang=scss&scoped=true"
import style1 from "./CatalogueFieldsMapper.vue?vue&type=style&index=1&id=b112c06a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b112c06a",
  null
  
)

export default component.exports